import React, {Component} from 'react';
import {withRouter} from "react-router";
import {translate} from 'react-i18next';
import Header from "./Header";
import Product from "../product";
import About from "./About";
import Advantages from "./Advantages";
import Rate from "./Rate";
//import Review from "./Review";
import Faq from "../faq/Faq";

import '../../css/home.scss';

class Home extends Component {
  render() {
    return (
      <div className={'home-container'}>
        <Header {...this.props}/>
        <Product {...this.props}/>
        <About {...this.props}/>
        <Advantages {...this.props}/>
        {<Rate {...this.props}/>}
        {/*<Review {...this.props}/>*/}
        <Faq {...this.props} faq_page={'home'}/>
      </div>
    )
  }
}

export default withRouter(translate('home')(Home));
